module.exports = __webpack_public_path__ + "img/icon1.7d31cd52.png";